module.exports = __webpack_public_path__ + "static/e-illu-1-b896979a4d0fcd15f3844bb8b9f11402.png";